import { Env, throwIfFalsy } from '@utils';

const APP_ENVS: string[] = ['local', 'dev', 'preprod', 'prod'];

throwIfFalsy(import.meta.env.VITE_API_URL, `'VITE_API_URL' variable must be set`);
throwIfFalsy(import.meta.env.VITE_SENTRY_DSN, `'VITE_SENTRY_DSN' variable must be set`);
throwIfFalsy(import.meta.env.VITE_APP_ENV, `'VITE_APP_ENV' variable must be set`);
throwIfFalsy(APP_ENVS.includes(import.meta.env.VITE_APP_ENV), `'VITE_APP_ENV' variable must be one of 'local', 'dev', 'preprod', 'prod'`);

export const ENV: Env = {
    API_URL: import.meta.env.VITE_API_URL,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    APP_ENV: import.meta.env.VITE_APP_ENV,
    APP_ENVS
};
